import React from 'react';
import { Link as RouterLink, Navigate } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Card, Stack, Link, Container, Typography } from '@mui/material';
// layouts
import AuthLayout from '../layouts/AuthLayout';
// components
import Page from '../components/Page';
import { MHidden } from '../components/@material-extend';
import { ForgotPasswordForm } from '../components/authentication/login';
import AuthService from '../services/auth.service';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2)
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function ForgotPassword() {
  const [isEmailSent, setIsEmailSent] = React.useState('');

  if (AuthService.getCurrentUser()) {
    return <Navigate to="/dashboard" />
  }

  return (
    <RootStyle title="Forgot Password | Vmeet">
      <AuthLayout></AuthLayout>

      <MHidden width="mdDown">
        <SectionStyle>
          <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}>
            Change your password
          </Typography>
          <img src="/static/illustrations/illustration_login.png" alt="login" />
        </SectionStyle>
      </MHidden>

      <Container maxWidth="sm">
        <ContentStyle>
          <Stack sx={{ mb: 5 }} style={{ marginBottom: '0px' }}>
            <Typography variant="h4" gutterBottom>
              {isEmailSent === '' ? 'Change your password' : 'Email sent'}
            </Typography>
            {isEmailSent === '' &&
              <Typography sx={{ color: 'text.secondary' }}>Enter your email below.</Typography>
            }
          </Stack>
          {/* <AuthSocial /> */}

          <br />
          <ForgotPasswordForm isEmailSent={isEmailSent} setIsEmailSent={setIsEmailSent} />
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
